import { render } from "./photographerOptinPage.vue?vue&type=template&id=4063abe4&scoped=true"
import script from "./photographerOptinPage.vue?vue&type=script&lang=js"
export * from "./photographerOptinPage.vue?vue&type=script&lang=js"

import "./photographerOptinPage.vue?vue&type=style&index=0&id=4063abe4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4063abe4"]])

export default __exports__